import MyLocationIcon from "@mui/icons-material/MyLocation";
import { IconButton } from "@mui/material";

import { ThreeDPanelState } from "@/shared/state/visualization";
import * as schema from "@/shared/state/visualization/schema/v1/three-d";

import { BabylonManager } from "./BabylonManager";
import { resolveFallbackEntity } from "./resolveFallbackEntity";

interface RecenterButtonProps {
  manager: BabylonManager | null;
  state: ThreeDPanelState;
}

/**
 * Third-person-only header control that re-frames the camera around
 * the tracked entity using the orbit camera's initial framing. Has no
 * meaning in orbit mode, so renders nothing when the active spec is
 * orbit or absent, or when there is no entity to recenter on. The
 * apply path is imperative (no dispatch); live framing isn't
 * persisted, which is consistent with the broader live-framing TODO.
 */
export function RecenterButton({ manager, state }: RecenterButtonProps) {
  const currentSpec = state.config?.camera;
  const fallbackEntity = resolveFallbackEntity(state.data.entities);
  if (
    !currentSpec ||
    currentSpec.type !== schema.CAMERA_TYPE.thirdPerson ||
    !fallbackEntity
  ) {
    return null;
  }
  const disabled = manager === null;

  const onClick = () => {
    manager?.recenter(fallbackEntity);
  };

  return (
    <IconButton
      aria-label="Recenter camera on target"
      disabled={disabled}
      onClick={onClick}
      size="small"
      title="Recenter on target"
    >
      <MyLocationIcon color="inherit" fontSize="small" />
    </IconButton>
  );
}
